import { Component, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DbService      } from '../../db.service';
import { SessionService } from '../../session.service';

import { Cadastro, DetalhePlano, OutPutGetCep, OutputGetCidade } from './cadastro.class'

import { Observable  } from 'rxjs';
import {environment} from '../../../environments/environment';

declare let gtag: (property: string, value: any, configs: any) => {};



@Component({
    selector: 'app-area-assinante-root',
    templateUrl: './area-assinante.component.html',
    styleUrls: ['./area-assinante.component.css']
})


export class AreaAssinanteComponent {
    @ViewChild(ModalDirective) modal: ModalDirective;
    form1           : FormGroup;
    form2           : FormGroup;
    item            : Cadastro = new Cadastro();
    detalhePlano    : DetalhePlano = new DetalhePlano();
    detalheProduto  : number = 0;
    mask            : string = "(00) 0000-00009";
    maskDocumento   : string = "000.000.000-00";
    showForm1       : boolean = false;
    showForm2       : boolean = false;
    itemCep         : OutPutGetCep;
    private itemBackup: Partial<Cadastro> = null;
    private url_Cep : string = "https://viacep.com.br/ws/";


    constructor(
        private dbService     : DbService,
        private sessionService: SessionService
    ) {
        this.form1 = new FormGroup({
            pessoal_nmCliente     : new FormControl('', Validators.required),
            pessoal_cdDocumento   : new FormControl('', Validators.required),
            pessoal_nuDocumento   : new FormControl('', Validators.required),
            pessoal_dsOcupacao    : new FormControl('', Validators.required),
            pessoal_dsCEP         : new FormControl('', Validators.required),
            pessoal_dsEndereco    : new FormControl('', Validators.required),
            pessoal_dsNumero      : new FormControl('', Validators.required),
            pessoal_dsComplemento : new FormControl(''),
            pessoal_dsBairro      : new FormControl(''),
            pessoal_dsMunicipio   : new FormControl('', Validators.required),
            pessoal_dsEstado      : new FormControl('', Validators.required),
            pessoal_dsOrganizacao : new FormControl('', Validators.required),
            pessoal_nuTelefone    : new FormControl('', Validators.required)
        });

        this.form2 = new FormGroup({
            pessoal_cdSenha : new FormControl('', [Validators.required, Validators.minLength(8)]),
            pessoal_cdSenha1: new FormControl('', [Validators.required, Validators.minLength(8), this.ValidaSenha()])
        });


        //EGS 30.03.2022 Google Analitics Log de login
        gtag('config', environment.googleAnalyticsId, {});
        gtag('event', 'area_assinante', {'method': ''});    
        
        this.load();
    }

    load() {
        // Garante que a sessão seja carregada
        this.sessionService.fnInicializarSessao();
        
        // Pequeno delay para garantir que a sessão seja carregada
        setTimeout(() => {
            console.log('Hash após inicialização:', this.sessionService.usuario.hash);
            this.dbService.post('Cliente/AreaAssinante', JSON.stringify(this.sessionService.usuario.hash)).subscribe(
                result => {
                    // Guarda objetos
                    this.item.pessoal_nmCliente     = result.pessoal_nmCliente;
                    this.item.pessoal_cdDocumento   = result.pessoal_cdDocumento;
                    this.item.pessoal_nuDocumento   = result.pessoal_nuDocumento;
                    this.item.pessoal_dsOcupacao    = result.pessoal_dsOcupacao;
                    this.item.pessoal_dsCEP         = result.pessoal_dsCEP;
                    this.item.pessoal_dsEndereco    = result.pessoal_dsEndereco;
                    this.item.pessoal_dsNumero      = result.pessoal_dsNumero;
                    this.item.pessoal_dsComplemento = result.pessoal_dsComplemento;
                    this.item.pessoal_dsBairro      = result.pessoal_dsBairro;
                    this.item.pessoal_dsMunicipio   = result.pessoal_dsMunicipio;
                    this.item.pessoal_dsEstado      = result.pessoal_dsEstado;
                    this.item.pessoal_dsOrganizacao = result.pessoal_dsOrganizacao;
                    this.item.pessoal_nuTelefone    = result.pessoal_nuTelefone;
                    this.item.pessoal_dsEmail       = result.pessoal_dsEmail;
                    this.item.planos                = result.planos;

                    // Sincroniza o formulário com os dados carregados para que ao editar os valores não sejam apagados
                    this.form1.patchValue({
                        pessoal_nmCliente: this.item.pessoal_nmCliente,
                        pessoal_cdDocumento: this.item.pessoal_cdDocumento,
                        pessoal_nuDocumento: this.item.pessoal_nuDocumento,
                        pessoal_dsOcupacao: this.item.pessoal_dsOcupacao,
                        pessoal_dsCEP: this.item.pessoal_dsCEP,
                        pessoal_dsEndereco: this.item.pessoal_dsEndereco,
                        pessoal_dsNumero: this.item.pessoal_dsNumero,
                        pessoal_dsComplemento: this.item.pessoal_dsComplemento,
                        pessoal_dsBairro: this.item.pessoal_dsBairro,
                        pessoal_dsMunicipio: this.item.pessoal_dsMunicipio,
                        pessoal_dsEstado: this.item.pessoal_dsEstado,
                        pessoal_dsOrganizacao: this.item.pessoal_dsOrganizacao,
                        pessoal_nuTelefone: this.item.pessoal_nuTelefone
                    });
                }
            );
        }, 100); // 100ms de delay
    }

    fnEditar1() {
        if (!this.showForm1) {
            // Entrando em modo edição: salva backup dos dados
            this.itemBackup = {
                pessoal_nmCliente: this.item.pessoal_nmCliente,
                pessoal_cdDocumento: this.item.pessoal_cdDocumento,
                pessoal_nuDocumento: this.item.pessoal_nuDocumento,
                pessoal_dsOcupacao: this.item.pessoal_dsOcupacao,
                pessoal_dsCEP: this.item.pessoal_dsCEP,
                pessoal_dsEndereco: this.item.pessoal_dsEndereco,
                pessoal_dsNumero: this.item.pessoal_dsNumero,
                pessoal_dsComplemento: this.item.pessoal_dsComplemento,
                pessoal_dsBairro: this.item.pessoal_dsBairro,
                pessoal_dsMunicipio: this.item.pessoal_dsMunicipio,
                pessoal_dsEstado: this.item.pessoal_dsEstado,
                pessoal_dsOrganizacao: this.item.pessoal_dsOrganizacao,
                pessoal_nuTelefone: this.item.pessoal_nuTelefone
            };
        }
        this.showForm1 = !this.showForm1;
    }

    fnCancelar1() {
        if (this.itemBackup) {
            // Restaura os dados ao estado anterior ao editar
            Object.assign(this.item, this.itemBackup);
            this.form1.patchValue(this.itemBackup);
            this.cbxDocumento_Changed();
            this.tbxTelefone_Changed();
            this.itemBackup = null;
        }
        this.showForm1 = false;
    }

    fnEditar2() {
        this.showForm2 = !this.showForm2;
        this.form2.reset();
    }

    fnExibirDetalhePlano(idPedido: number, idProduto: number) {
        this.dbService.get('Assinatura/DetalhePlano/?idPedido=' + idPedido + '&idProduto=' + idProduto).subscribe((result: DetalhePlano) => {
            // Guarda objetos
            this.detalhePlano = result;
            this.detalheProduto = idProduto;

            // Exibe tela
            this.modal.show();
        });
    }

    fnSalvar1() {
        // Valida formulário
        if (!this.form1.valid) {
            // Exibe erros
            for (let ctrl in this.form1.controls) { this.form1.controls[ctrl].markAsTouched(); }
        } else {
            this.dbService.post('Cliente/AtualizarDadosCadastrais/?hash=' + this.sessionService.usuario.hash, this.item).subscribe(result => {
                if (result.confirmacao === true) {
                    this.fnEditar1();
                }
            });
        }
    }

    fnSalvar2() {
        // Valida formulário
        if (!this.form2.valid) {
            // Exibe erros
            for (let ctrl in this.form2.controls) { this.form2.controls[ctrl].markAsTouched(); }
        } else {
            this.dbService.post('Cliente/AtualizarSenha/?hash=' + this.sessionService.usuario.hash, this.item.pessoal_cdSenha).subscribe(result => {
                if (result.confirmacao === true) {
                    this.fnEditar2();
                }
            });
        }
    }

    ValidaSenha(): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            if (this.item.pessoal_cdSenha === this.item.pessoal_cdSenha1) {
                return null;
            }
            else {
                return { comparacao: true }
            }
        };
    }

    cbxDocumento_Changed() {
        if (this.item.pessoal_cdDocumento === '1') {
            this.maskDocumento = "000.000.000-00";
        } else {
            this.maskDocumento = "00.000.000/0000-00";
        }
    }

    tbxTelefone_Blur() {
        if (this.item.pessoal_nuTelefone.trim().length === 10) {
            this.item.pessoal_nuTelefone += " ";
        }
    }

    tbxTelefone_Changed() {
        if (this.item.pessoal_nuTelefone.trim().length === 11) {
            this.mask = "(00) 00000-0009";
        } else {
            this.mask = "(00) 0000-00009";
        }
    }

   /* ===========================================================================================
    *  Edinaldo FIPE
    *  Dez/2020 
    *  Pesquisa o Logradouro pelo CEP
    ===========================================================================================*/
    fnCep(cep: string) {
        if (!cep) return;
        cep = String(cep).replace(/ /gi, '').replace(/\-/gi, '');

        if (cep.length === 8) 
        {
            var sUrl = this.url_Cep + cep + '/json/'; 
            this.getCEPs(sUrl);
        }
    }    
    private getCEPs(url) {
        fetch(url)
          .then(res => res.json())
          .then(json => this.showContent(json))
      }
      
    private showContent(cep) {
        this.item.pessoal_dsCEP         = cep.cep;
        this.item.pessoal_dsEndereco    = cep.logradouro;
        this.item.pessoal_dsNumero      = '';
        this.item.pessoal_dsComplemento = '';
        this.item.pessoal_dsBairro      = cep.bairro;
        this.item.pessoal_dsMunicipio   = cep.localidade;
        this.item.pessoal_dsEstado      = cep.uf;
    }


}
